
/**
 * @export
 * @enum {string}
 */
export enum ChangeRequestStatus {
    NEW = 'NEW',
    WAITING_REVIEW = 'WAITING_REVIEW',
    IN_REVIEW = 'IN_REVIEW',
    WAITING_APPROVE = 'WAITING_APPROVE',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    REOPENED = 'REOPENED'
}